import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export interface EnterpriseStatus {
  enterprise: boolean;
  app_metadata?: any;
}

export interface UpdateEnterpriseRequest {
  enterprise: boolean;
}

/**
 * Get the current user's enterprise status
 */
export const getEnterpriseStatus = async (token: string): Promise<EnterpriseStatus> => {
  const response = await axios.get(`${API_URL}/api/admin/user/enterprise`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

/**
 * Update the current user's enterprise status
 */
export const updateEnterpriseStatus = async (
  enterprise: boolean,
  token: string
): Promise<EnterpriseStatus> => {
  const response = await axios.patch(
    `${API_URL}/api/admin/user/enterprise`,
    { enterprise },
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  return response.data;
};
